import { createAction, props } from '@ngrx/store';
import { IEmployeeDetailRequest } from '../models/employee-detail.model';
import { IHomeAddressResponse } from '../models/home-address.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

//CURRENT
export const loadHomeAddresss = createAction('[HomeAddress] Load HomeAddresss', props<{ request: string }>());

export const loadHomeAddresssSuccess = createAction('[HomeAddress] Load HomeAddresss Success', props<{ response: IHomeAddressResponse }>());

export const loadHomeAddresssFailure = createAction(
  '[HomeAddress] Load HomeAddresss Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

//PREVIOUS
export const loadPreviousHomeAddress = createAction('[HomeAddress] Load Previous HomeAddress', props<{ request: string }>());

export const loadPreviousHomeAddressSuccess = createAction(
  '[HomeAddress] Load Previous HomeAddress Success',
  props<{ response: IHomeAddressResponse[] }>()
);

export const loadPreviousHomeAddressFailure = createAction(
  '[HomeAddress] Load Previous HomeAddress Failure',
  props<{ error: Error | any }>()
);
